import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import './assets/css/main.css';
import { VueMaskDirective } from 'v-mask'; // Importa la directiva específica

const app = createApp(App);

app.use(router);

// En lugar de .use(VueMask), regístrala como directiva
app.directive('mask', VueMaskDirective);

// Aparición suave al entrar en viewport, sin dependencias externas.
app.directive('reveal', {
  mounted(el, binding) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const delay = Number(binding.value?.delay) || 0;
    el.classList.add('reveal');
    el.style.transitionDelay = `${delay}ms`;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        el.classList.add('reveal-visible');
        observer.unobserve(el);
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    observer.observe(el);
    el._revealObserver = observer;
  },
  unmounted(el) {
    el._revealObserver?.disconnect();
  }
});

app.mount("#app");